import { MouseEvent, useState } from 'react';
import { Dialog, Popover, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { Button, Text } from '@cyberpion/cyberpion-ui';
import { RestApi } from '../../services/rest-api.service';
import { AppLoading } from '../appLoading/appLoading';
import { showError, showSuccess } from '../../../features/AlertSlice';
import { useDispatch } from 'react-redux';
import { Common } from '../../services/common.service';
import { getRows } from '../../../features/GridSlice';

interface IAddCommentDialog {
  selectedRows?: any[];
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function AddCommentDialog(props: IAddCommentDialog) {
  const [loading, setLoading] = useState<boolean>(false);
  const [comment, setComment] = useState<string>('');
  const [popoverEl, setPopoverEl] = useState<HTMLElement | null>(null);
  const dispatch = useDispatch<any>();

  const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
    setPopoverEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setPopoverEl(null);
  };
  const popoverOpen = Boolean(popoverEl);
  const handleClose = () => props.setOpen(false)

  const handleSubmit = () => {
    setLoading(true);
    const url = Common.AddMsspAccountIfNeeded('remediation/action-items/comments/');
    const data = {
      ids: props.selectedRows,
      comment
    };
    RestApi.setData(url, data, 'POST').subscribe(
      (response: any) => {
        dispatch(getRows());
        dispatch(showSuccess('Updated Successfully'))
        setComment('');
        setLoading(false);
        handleClose()
      },
      error => {
        dispatch(showError('Failed to Add Comment'))
        setLoading(false);
        handleClose()
      }
    );
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
    >
      <DialogTitle>
        <Text textSize={20} weight={500}>
          Add Bulk Comment
        </Text>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          <Text textSize={16}>
            Your comment will be applied to all {props?.selectedRows?.length} selected assets.
          </Text>
           <Popover
            sx={{
              pointerEvents: 'none',
            }}
            open={popoverOpen}
            anchorEl={popoverEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
             {props.selectedRows?.map(row => (
               <Text textSize={14} style={{ padding: 10 }} textColor="#B7BBC5">{row}</Text>
             ))}
          </Popover>
        </DialogContentText>
        <textarea
          value={comment}
          onChange={e => setComment(e.target.value)}
          placeholder="Add Comment"
          rows={7}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          buttonStyle="secondary"
          text="Cancel"
          type="button"
          size="medium"
        />
        <Button
          onClick={handleSubmit}
          buttonStyle="main"
          text="Add Comment"
          type="button"
          size="medium"
          disabled={!comment}
        />
      </DialogActions>
      {loading && <AppLoading />}
    </Dialog>
  );
}
